import './ActivityStrip.scss';

interface ActivityStripProps {
  postCount?: number;
  vouchesGiven?: number | null;
  joinLabel?: string | null;
  lastActiveLabel?: string | null;
}

const plural = (n: number, word: string) => `${word}${n === 1 ? '' : 's'}`;

export function ActivityStrip({
  postCount = 0,
  vouchesGiven,
  joinLabel,
  lastActiveLabel,
}: ActivityStripProps) {
  return (
    <div className="activity-strip">
      <span className="activity-strip__stat">
        <b>{postCount}</b> {plural(postCount, 'post')}
      </span>
      {typeof vouchesGiven === 'number' ? (
        <>
          <span className="activity-strip__sep" aria-hidden="true" />
          <span className="activity-strip__stat">
            <b>{vouchesGiven}</b>{' '}
            {vouchesGiven === 1 ? 'vouch given' : 'vouches given'}
          </span>
        </>
      ) : null}
      {joinLabel ? (
        <>
          <span className="activity-strip__sep" aria-hidden="true" />
          <span className="activity-strip__muted">Joined {joinLabel}</span>
        </>
      ) : null}
      {lastActiveLabel ? (
        <>
          <span className="activity-strip__sep" aria-hidden="true" />
          <span className="activity-strip__muted">
            Active {lastActiveLabel}
          </span>
        </>
      ) : null}
    </div>
  );
}
